export default __webpack_public_path__ + "a5e90695a92bb81e0924fd55367e1c93.svg";